/**
 * Copyright 2024 Design Barn Inc.
 */

import type { ConsentCategories } from '@lottiefiles/consent-banner';

const CONSENT_COOKIE_NAME = 'lf_cookie_preferences';
const CONSENT_CATEGORIES: ReadonlyArray<ConsentCategories> = [
  'essential',
  'functionality',
  'performance',
  'marketing',
  'analytics',
  'social',
  'geolocation',
];

const isConsentCategory = (value: unknown): value is ConsentCategories =>
  typeof value === 'string' && CONSENT_CATEGORIES.includes(value as ConsentCategories);

export const getStoredAcceptedCategories = (): ConsentCategories[] | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookie = document.cookie
    .split(';')
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith(`${CONSENT_COOKIE_NAME}=`));

  if (!cookie) {
    return null;
  }

  try {
    const parsed = JSON.parse(decodeURIComponent(cookie.slice(CONSENT_COOKIE_NAME.length + 1))) as {
      categories?: unknown;
    };

    if (!Array.isArray(parsed.categories)) {
      return null;
    }

    const categories = parsed.categories.filter(isConsentCategory);

    return categories.length === parsed.categories.length ? categories : null;
  } catch {
    return null;
  }
};
